import { useState } from "react";
import SuccessModal from "../../pages/SucessModal";
import ProgressBar from "../../pages/ProgressBar";
import BankDetailsStep from "../../pages/BankDetailsStep";
import BasicDetailsStep from "../../pages/BasicDetailsStep";
import BusinessDetailsStep from "../../pages/BusinessDetailsStep";
import KYCVerificationStep from "../../pages/KYCVerificationStep";
import { config } from "../../utils/config";

const TOTAL_STEPS = 4;

export default function OnboardingForm() {
    const [currentStep, setCurrentStep] = useState(1);
    const [showSuccess, setShowSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const { apiEndpoint } = config;
    const [formData, setFormData] = useState({
        business: {},
        basic: {},
        bank: {},
        kyc: {}
    });

    const handleNext = async () => {
        try {
            setLoading(true);
            let payload = {};
            let url = "";
            const token = sessionStorage.getItem("us_st_d");
            if (currentStep === 1) {
                payload = formData.business;
                url = `${apiEndpoint}/seller-bussiness-info`;
            }
            if (currentStep === 2) {
                payload = formData.basic;
                url = `${apiEndpoint}/basic-details`;
            }
            if (currentStep === 3) {
                payload = formData.bank;
                url = `${apiEndpoint}/bank-details`;
            }
            if (currentStep === 4) {
                payload = formData.kyc;
                url = `${apiEndpoint}/kyc`;
            }
            const res = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Custom-Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            if (!res.ok) {
                alert("API Error");
                setLoading(false);
                return;
            }
            if (currentStep < TOTAL_STEPS) {
                setCurrentStep((prev) => prev + 1);
            } else {
                setShowSuccess(true);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        if (currentStep > 1) setCurrentStep((s) => s - 1);
    };

    const renderStep = () => {
        switch (currentStep) {
            case 1:
                return (
                    <BusinessDetailsStep
                        data={formData.business}
                        setData={(data) =>
                            setFormData((prev) => ({ ...prev, business: data }))
                        }
                    />
                );

            case 2:
                return (
                    <BasicDetailsStep
                        data={formData.basic}
                        setData={(data) =>
                            setFormData((prev) => ({ ...prev, basic: data }))
                        }
                    />
                );

            case 3:
                return (
                    <BankDetailsStep
                        data={formData.bank}
                        setData={(data) =>
                            setFormData((prev) => ({ ...prev, bank: data }))
                        }
                    />
                );

            case 4:
                return (
                    <KYCVerificationStep
                        data={formData.kyc}
                        setData={(data) =>
                            setFormData((prev) => ({ ...prev, kyc: data }))
                        }
                    />
                );
            default:
                return null;
        }
    };

    return (
        <>
            <SuccessModal show={showSuccess} onClose={() => setShowSuccess(false)} />
            <div className="bg-light min-vh-100">
                <div className="container px-5">
                    <ProgressBar currentStep={currentStep} />
                </div>

                <main className="container pb-3">
                    <div className="px-5">

                        {renderStep()}

                        <div className="d-flex justify-content-between mt-4">

                            {currentStep > 1 ? (
                                <button
                                    onClick={handleBack}
                                    className="bg-white px-4 rounded fw-semibold"
                                    style={{ border: "1px solid #F75710", color: "#F75710" }}
                                >
                                    Back
                                </button>
                            ) : <div />}

                            <button
                                onClick={handleNext}
                                disabled={loading}
                                className="text-white px-4 py-2 rounded fw-semibold"
                                style={{
                                    background: "linear-gradient(90deg, #F75710, #FC8809)",
                                    border: "none"
                                }}
                            >
                                {loading
                                    ? "Processing..."
                                    : currentStep === TOTAL_STEPS
                                        ? "Submit"
                                        : "Next"}
                            </button>

                        </div>
                    </div>
                </main>
            </div>
        </>
    );
}
